import { Box, Button, Container, Typography } from "@mui/material";
import { ConsentContext, Hermes, NextPageWithLayout } from "@cm-websites/common";
import { NavigationAndFooterLayout } from "../layouts";
import { NextSeo } from "next-seo";
import NextLink from "next/link";
import React from "react";

export const HaendlerSuchePage: NextPageWithLayout = () => {
  const { addGrant, hasGrant } = React.useContext(ConsentContext);
  const grant = React.useMemo(() => ({ id: "google-maps" }), []);
  const [hasMapsGrant, setHasMapsGrant] = React.useState(false);
  const unlock = () => addGrant(grant);

  React.useEffect(() => {
    setHasMapsGrant(hasGrant(grant));
  }, [grant, hasGrant]);

  return (
    <React.Fragment>
      <NextSeo
        description="Bitte gib eine Adresse ein, um Händler in der Nähe zu finden, die unsere Krimidinner und Krimispiele anbieten."
        title="Händler finden | Krimidinner für Zuhause"
      />
      <Container maxWidth="md" sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 2 } }}>
        <Typography variant="h1" sx={{ pb: 6 }}>
          Händler finden
        </Typography>

        {hasMapsGrant && (
          <React.Fragment>
            <Typography variant="body1" paragraph>
              Bitte gib eine Adresse ein, um nach Händlern in deiner Nähe zu suchen, die unsere
              Krimidinner für Zuhause anbieten. Es werden dir automatisch Geschäfte in einem Radius von
              25 km angezeigt.
            </Typography>

            <Typography variant="body1" paragraph>
              Wir empfehlen dir, beim Händler im Vorfeld nachzufragen, ob das gewünschte Krimidinner auch
              vorrätig ist.
            </Typography>
          </React.Fragment>
        )}

        {!hasMapsGrant && (
          <Box sx={{ pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}>
            <Typography variant="body1" paragraph>
              Wir verwenden die Google Maps API für unsere Händlersuche. Damit du nach Händlern suchen
              kannst, die unsere Krimidinner für Zuhause anbieten, benötigen wir deine Einwilligung zum
              Laden externer Medien. Nähere Informationen findest du in unserer{" "}
              <NextLink href="/datenschutz">Datenschutzerklärung</NextLink>.
            </Typography>
            <Button variant="contained" sx={{ mt: 1 }} onClick={unlock}>
              Externen Inhalt laden
            </Button>
          </Box>
        )}
      </Container>
      {hasMapsGrant && <Hermes />}
    </React.Fragment>
  );
};

HaendlerSuchePage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default HaendlerSuchePage;
